import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RawReadBillingResponse } from '../types/billing';
import type { RequestOptions } from '../types/common';
import type {
  RawChangeOrderBillingRequest,
  RawCreateBillingOrderRequest,
  RawCreateManualOrderRequest,
  RawOrderResponse,
} from '../types/order';

export function createOrderApi(http: Http) {
  return {
    /** POST /api/v2/orders/billing/{billingId} — 빌링(정기 결제) 주문 생성 */
    async createBillingOrder(
      billingId: string,
      data: RawCreateBillingOrderRequest,
      options?: RequestOptions,
    ): Promise<RawOrderResponse> {
      const res = await http.post<RawOrderResponse>(endpoints.order.billing(billingId), data, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** POST /api/v2/orders/manual — 무통장입금 주문 생성 */
    async createManualOrder(
      data: RawCreateManualOrderRequest,
      options?: RequestOptions,
    ): Promise<RawOrderResponse> {
      const res = await http.post<RawOrderResponse>(endpoints.order.manual, data, {
        signal: options?.signal,
      });
      return res.data;
    },

    /**
     * PUT /api/v2/orders/{orderId}/billing — 주문 결제수단(빌링키) 변경.
     * 응답 = 변경된 결제수단 단건(`{ billing }`, 빌링 단건 응답 재사용).
     */
    async changeOrderBilling(
      orderId: number,
      data: RawChangeOrderBillingRequest,
      options?: RequestOptions,
    ): Promise<RawReadBillingResponse> {
      const res = await http.put<RawReadBillingResponse>(
        endpoints.order.changeBilling(orderId),
        data,
        { signal: options?.signal },
      );
      return res.data;
    },
  };
}
